const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#328538',
                hover: '#237629'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};